export const AdBannerStorageKey = 'ad_banner';
export const AdBannerMediaQueryThreshold = '(max-width: 990px)';
